import React from 'react';

import Tabs from 'react/containers/layout/tabs/Tabs';
import AccessDenied from 'react/containers/pages/AccessDenied';
import CrudTab from 'react/containers/pages/CrudTab';
import * as TabsRouters from 'react/containers/pages';
import TicketHub from 'react/components/TicketHub';
import ToastContainer from 'react/components/ToastContainer';
import BottomContainer from 'react/containers/layout/Bottom';

import EventDetailsModal from 'react/containers/modals/EventDetailsModal/EventDetailsModal';
import RouteAssignmentsModal from 'react/containers/modals/RouteAssignments/RouteAssignmentsModal';
import RouteDivisionModal from 'react/containers/modals/RouteDivision/RouteDivisionModal';
import MainSupervisorModal from 'react/containers/modals/MainSupervisorModal/MainSupervisorModal';

import Sidebar from 'react/containers/layout/sidebar';
import LogDetailsModal from 'react/containers/modals/LogDetailsModal';
import PhotoAlbumModal from 'react/containers/modals/PhotoAlbumModal';

import { actionCreators as integrationActions } from 'react/api/actions/integrations';
import { actionCreators as localzIntegrationActions } from 'react/api/actions/localzIntegration';

export class Content extends React.Component {
  componentDidMount() {
    const { panels, openPanelAtLogin } = this.props;
    openPanelAtLogin(panels);

    this.fetchIntegrations();
  }

  fetchIntegrations() {
    const tenant = Greenmile.Utils?.getTenant() ?? 'lts';
    const featuresStates = GreenmileReduxStore.getState().features;
    window.globalStore.dispatch(integrationActions.fetchIntegrations());

    const localzIsEnabled =
      featuresStates.has('LOCALZ_INTEGRATION') &&
      featuresStates.get('LOCALZ_INTEGRATION')?.enabled;

    if (localzIsEnabled) {
      window.globalStore.dispatch(
        localzIntegrationActions.fetchIntegration({
          tenant
        })
      );
    }
  }

  render() {
    const { featureStates, routeDivisionModal: routeDivisionState, menus } = this.props;
    const ticketSupportToggle = featureStates?.get?.('ENABLE_TICKET_SUPPORT');
    const isRouteDivisionModalEnabled = routeDivisionState?.get('isOpen');

    return (
      <div id="app">
        <Sidebar menus={menus} />
        <main className="mainContainer">
          <Tabs
            accessDeniedTag={AccessDenied}
            defaultTag={CrudTab}
            tags={TabsRouters}
          />
          <BottomContainer />
          <LogDetailsModal />
          <EventDetailsModal />
          <RouteAssignmentsModal />
          <PhotoAlbumModal />
          <MainSupervisorModal />
          {isRouteDivisionModalEnabled && <RouteDivisionModal />}
          {ticketSupportToggle?.enabled && <TicketHub />}
          <ToastContainer />
        </main>
      </div>
    );
  }
}

export default Content;
